import { PropsWithChildren } from "react";
import { listContainer } from "./styles.css";

export const ItemsList = ({
  large,
  children,
}: PropsWithChildren<{ large?: boolean }>) => {
  const variant = large ? "large" : "default";
  return <div className={listContainer[variant]}>{children}</div>;
};
